import React, { useState } from "react";
import { connect } from "react-redux";
import { bool } from "prop-types";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import { actions as investmentfundsActions } from "reducers/investmentfunds";

import * as i18n from "util/i18n";

import { useTransaction } from "hooks/useTransactions";
import { transactionStatus } from "pages/transactions/constants";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import Avatar from "pages/_components/Avatar";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import {
    TransactionCard,
    TransactionHeader,
    TransactionInfo,
    TransactionSign,
} from "pages/_components/TransactionCard";

const AddAccountTransactionPage = ({ isDesktop }) => {
    const { pathname } = useLocation();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const formatTransaction = (data, idTransaction) => {
        const formData = {
            idTransaction,
            ...data,
        };

        return { ...formData };
    };
    const { transaction, dispatch, handleSignTransaction, showSignButton, push, id } = useTransaction(
        "/investmentFunds/accounts/add/confirm",
        investmentfundsActions.setAccountData,
        null,
        formatTransaction,
    );
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "activities.investmentFunds.addAccount.send",
        id,
        "investmentfunds",
    );

    const isBackoffice = pathname.includes("backoffice");
    const transactionData = {
        name: transaction?.data?.name || "",
        mail: transaction?.data?.mail || "",
        phone: transaction?.data?.phone || "",
        accountSummary: transaction?.data?.accountSummary || "",
        username: transaction?.data?.username || "",
    };
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
    };

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="investmentfunds" />
            {!isBackoffice && <ResponsiveHeader ticket metaTitle="activities.investmentFunds.addAccount.send" />}
            <MainContainer showLoader={!transaction.data}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="activities.investmentFunds.addAccount.send" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body echeq-massive-emit">
                                        <div
                                            className="grid-table-data flex"
                                            style={{
                                                gridArea: "1 / 1 / span 1 / span 8",
                                                justifyContent: "center",
                                                flexDirection: "row",
                                                textAlign: "center",
                                            }}>
                                            <div style={{ alignItems: "center" }}>
                                                <div
                                                    className="grid-table-data flex align-items-end"
                                                    style={{ flexDirection: "row" }}>
                                                    {isDesktop && (
                                                        <Avatar
                                                            user={{
                                                                userFullName: transactionData.username,
                                                                defaultAvatarId: 0,
                                                            }}
                                                        />
                                                    )}
                                                    <div
                                                        className="custom-data"
                                                        style={{ textAlign: "start", marginLeft: "5px" }}>
                                                        <CustomText
                                                            textType="I18N"
                                                            text="creditBill.cuit.label"
                                                            className="custom-data-title"
                                                        />
                                                        <span className="custom-text custom-data-value">
                                                            {transactionData.username}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view-more-data-button" id="element-to-ignore">
                                            <div className="ticket__divider inside-ticket__body">
                                                <div className="ticket__notch ticket__notch--left"> </div>
                                                <div className="ticket__notch ticket__notch--right"> </div>
                                            </div>
                                            <Button
                                                aria-expanded={showMoreData ? "true" : "false"}
                                                className="more-button"
                                                label={showMoreData ? "echecks.seeLess.button" : "transfers.showMore"}
                                                bsStyle="link"
                                                onClick={handleSeeMoreData}
                                                image={
                                                    showMoreData
                                                        ? "figma/icon/arrow-up.svg"
                                                        : "figma/icon/arrow-down.svg"
                                                }
                                            />

                                            <div
                                                className={`view-more-data full-width view-discounts-echeq ${
                                                    showMoreData ? "expand " : "collapse"
                                                }`}>
                                                <GridTable className="equivalent-total-balance">
                                                    <GridTable.Container columnsTemplate="fixed" columns={2}>
                                                        <GridTable.Data rowStart={1} columnStart={1}>
                                                            <TransactionInfo
                                                                fieldString="Nombre de la Cuenta"
                                                                value={transactionData.name}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data
                                                            rowStart={isDesktop ? 1 : 2}
                                                            columnStart={isDesktop ? 2 : 1}>
                                                            <TransactionInfo
                                                                fieldString="Mail"
                                                                value={transactionData.mail}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data rowStart={isDesktop ? 2 : 3} columnStart={1}>
                                                            <TransactionInfo
                                                                fieldString="Teléfono"
                                                                value={transactionData.phone}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data
                                                            rowStart={isDesktop ? 2 : 4}
                                                            columnStart={isDesktop ? 2 : 1}>
                                                            <TransactionInfo
                                                                fieldString="Resúmen de Cuenta"
                                                                value={transactionData.accountSummary}
                                                            />
                                                        </GridTable.Data>
                                                    </GridTable.Container>
                                                </GridTable>
                                                <TransactionSign
                                                    hasVaucher
                                                    isDesktop={isDesktop}
                                                    noDate
                                                    isSmall
                                                    creationTime
                                                    showMoreData={showMoreData}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={showSignButton || isFinished ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${showSignButton || isFinished ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                            {isFinished && (
                                <>
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={handleDownload}
                                            label="global.download"
                                            className="btn btn-primary"
                                            image="images/download.svg"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

AddAccountTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default connect()(AddAccountTransactionPage);
